import { ActionButton, ActionButtonType } from "@octopusdeploy/design-system-components";
import type { EnvironmentResource } from "@octopusdeploy/octopus-server-client";
import pluralize from "pluralize";
import React from "react";
import { environmentChipList } from "~/components/Chips";
import Dialog from "~/components/Dialog/Dialog";
import { DialogLayout } from "~/components/DialogLayout/DialogLayout";
import { Text } from "~/components/form";
import styles from "./style.module.less";
interface OverrideDeploymentFreezeDialogProps {
    show: boolean;
    activeFreezes: {
        Name: string;
        Environments: string[];
    }[];
    allEnvironments: EnvironmentResource[];
    onClosed(): void;
    onContinueClick(reason: string): Promise<void>;
}
interface OverrideDeploymentFreezeDialogState {
    reason: string;
}
export class OverrideDeploymentFreezeDialog extends React.Component<OverrideDeploymentFreezeDialogProps, OverrideDeploymentFreezeDialogState> {
    constructor(props: OverrideDeploymentFreezeDialogProps) {
        super(props);
        this.state = {
            reason: "",
        };
    }
    render() {
        const cont = <ActionButton key="Continue" label={"Override and deploy"} type={ActionButtonType.Save} onClick={() => this.props.onContinueClick(this.state.reason)}/>;
        const cancel = <ActionButton key="Cancel" label="Cancel" onClick={() => this.props.onClosed()}/>;
        return (<Dialog open={this.props.show} dialogWidth="800px">
                <DialogLayout actions={[cancel, cont]} title={"Override deployment freezes"} closeDialog={this.props.onClosed}>
                    You will override <b>{this.props.activeFreezes.length}</b> active deployment {pluralize("freeze", this.props.activeFreezes.length)} with this deployment:
                    <div>
                        <ul className={styles.freezeList}>
                            {this.props.activeFreezes.map((f, ix) => (<li key={f.Name + ix}>
                                    {f.Name} has frozen {environmentChipList(this.props.allEnvironments, f.Environments)}
                                </li>))}
                        </ul>
                    </div>
                    <Text key="reason" id="reason" name="Reason" label="Provide a reason for overriding the deployment freezes" autoFocus={true} accessibleName={"Reason"} customMargins="0 0 0.5rem 0" value={this.state.reason} onChange={(newValue: string) => this.setState({ reason: newValue })}/>
                </DialogLayout>
            </Dialog>);
    }
    static displayName = "OverrideDeploymentFreezeDialog";
}
